import { Button } from "components/Button/Button";
import Datepicker from "components/DatePicker/DatePicker";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { UnitDictionary } from "pages/InventoryAndSales/Inventory/BaseDefinitionAndSetting/Unit/components/UnitDictionary";
import { useEffect, useState } from "react";
import { GUID_EMPTY, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { RoundWithRoundingPlace, trans, uuidv4 } from "utils/helpers";
import { PriceDetails } from "../components/PriceDetails";
import { getTaxList } from "./api";
import { WarehouseDictionaryWithAccess } from "../SalesInvoice/components/WarehouseDictionary/WarehouseDictionaryWithAccess";
import { WarehouseTreeForm } from "../SalesInvoice/components/WarehouseTreeForm/WarehouseTreeForm";
import { SalesInvoiceDetailType } from "./type";
import { ItemsForSell } from "../components/ItemsForSell/ItemsForSell";
import { MessageType } from "types/enum";
import { PriceInput } from "components/PriceInput/PriceInput";

interface SalesInvoiceFormProps {
  onHide: () => void;
  SalesInvoiceDetailCallBack?: (e: any) => void;
  selectedObj?: any;
  mode: any;
  priceList?: any;
  lastWarehouse?: any;
  invoiceConstraint?: any;
  setLastWarehouse: (e: any) => void;
  originalQty?: any;
  currency?: any;
  MasterUnitPriceRoundingPlace?: any;
}

export const SalesReturnInvoiceDetailForm = ({
  lastWarehouse = null,
  invoiceConstraint,
  setLastWarehouse,
  priceList,
  selectedObj,
  mode,
  onHide,
  SalesInvoiceDetailCallBack,
  originalQty,
  currency,
  MasterUnitPriceRoundingPlace
}: SalesInvoiceFormProps) => {
  const [resetForm, setResetForm] = useState(false);
  const [loading, setLoading] = useState<any>(true);
  const [userChanges, setUserChanges] = useState({});
  const [ExpireDate, setExpireDate] = useState<any>();
  const [showTree, setShowTree] = useState<any>();
  const [showWarehouseTree, setShowWarehouseTree] = useState<any>();
  const [priceListDetail, setPriceListDetail] = useState<any>([]);
  const [detailPriceData, setDetailPriceData] = useState<any>({
    Price: 0,
    Discount: 0,
    SubTotalPrice: 0,
    Qty1: mode != "create" ? selectedObj?.Qty1 : 1,
    Qty2: mode != "create" ? selectedObj?.Qty2 : 1,
  });
  const [itemData, setItemData] = useState<any>(null);
  const [warehouseData, setWarehouseData] = useState<any>(lastWarehouse);
  const [dictionaryName, setDictionaryName] = useState<any>({});
  const [save_Exit, setSave_Exit] = useState<boolean>(false);
  const [rate, setRate] = useState<any>(1);
  const [numberOfSalesUnit, setNumberOfSalesUnit] = useState<any>();

  const [showInvalidValue, setShowInvalidValue] = useState(false);
  const handleSalesInvoiceFormSubmit = async (event) => {
    event.preventDefault();
    let data: SalesInvoiceDetailType = {
      SalesInvoiceDetailId: selectedObj.SalesInvoiceDetailId,
      Id: mode != "create" ? selectedObj?.Id : uuidv4(),
      SourceId: selectedObj?.SourceId,
      SourceData: selectedObj?.SourceData,
      ItemId: selectedObj?.ItemId,
      SalesUnitPrice:detailPriceData.SalesUnitPrice,
      SalesUnitId: detailPriceData.SalesUnitId,
      Unit1Id:
        event.target.Unit1Id?.value == "" ? null : event.target.Unit1Id?.value,
      Unit2Id:
        event.target?.Unit2Id?.value == ""
          ? null
          : event.target?.Unit2Id?.value,
      ReturnableQty:selectedObj?.ReturnableQty,
      ItemCode: selectedObj?.ItemCode,
       GrandTotalPrice: +event.target.GrandTotalPrice.value.replaceAll(",", ""),
      CustomerDiscountPercent:event.target.CustomerDiscountPercent ? +event.target.CustomerDiscountPercent.value.replaceAll(",", ""):0,
       CustomerDiscount: event.target.CustomerDiscount? +event.target.CustomerDiscount.value.replaceAll(",", ""):0,
      WarehouseId: warehouseData.WarehouseId ?? selectedObj?.WarehouseId,
      WarehouseDetailId:
        warehouseData.WarehouseDetailId ?? selectedObj?.WarehouseDetailId,
      Warehouse: warehouseData.WarehouseTitle ?? selectedObj.Warehouse,
      WarehouseDetail:
        warehouseData?.WarehouseDetail ?? selectedObj?.WarehouseDetail,
      Item: selectedObj?.Item,
      Qty1: +event.target.Qty1?.value,
      Unit1: dictionaryName?.Unit1 ? dictionaryName?.Unit1 : null,
      Qty2: +event.target?.Qty2?.value,
      Unit2: dictionaryName?.Unit2 ? dictionaryName?.Unit2 : null,
      UnitPrice: selectedObj.UnitPrice,
      TotalPrice: parseFloat(event.target.TotalPrice?.value.replace(/,/g, "")),
      SubTotalPrice:event.target.SubTotalPrice?.value? parseFloat(event.target.SubTotalPrice?.value.replace(/,/g, '')):0,
      Unit1Price:numberOfSalesUnit===1?detailPriceData.SalesUnitPrice:parseFloat(event.target.Unit1Price?.value.replace(/,/g, '')),
      Unit2Price:numberOfSalesUnit===2?detailPriceData?.SalesUnitPrice:parseFloat(event.target.Unit2Price?.value.replace(/,/g, '')),
        Tax:  parseFloat(event.target.Tax?.value.replace(/,/g, '')),
      TaxRate:selectedObj.TaxRate,
      DiscountPercent: +event.target.DiscountPercent?.value.replaceAll(",", ""),
      Discount: +event.target.Discount?.value.replaceAll(",", ""),
      Price: detailPriceData.price
        ? detailPriceData.price - detailPriceData.Discount
        : selectedObj.Price, //تخفیف کم میشود
   
     

      ItemTechnicalCode: selectedObj.ItemTechnicalCode,
      Description: event.target.Description?.value,
    };
    if (!showInvalidValue) {
      SalesInvoiceDetailCallBack && SalesInvoiceDetailCallBack(data);
      setItemData(null);
      setResetForm(true);
      setLastWarehouse(warehouseData);
      setUserChanges({});
      setDetailPriceData({
        Price: 0,
        Discount: 0,
        SubTotalPrice: 0,
        Qty1: mode != "create" ? selectedObj?.Qty1 : 1,
        Qty2: mode != "create" ? selectedObj?.Qty2 : 1,
      });
      sessionStorage.setItem("changingforms", "false");
      // Toast("msg_saveddatasuccessfully", "success");
      Toast("msg_saveddatasuccessfully", MessageType.success);


      try {
      } catch (error) {}
      if (save_Exit) {
        onHide();
      }
    } else {
      // Toast(trans("Msg_DeleteItemFromRowOperationsOfDataGrid"), "error");
      Toast(trans("Msg_DeleteItemFromRowOperationsOfDataGrid"), MessageType.error);

    }
  };

  const itemCodeHandeler = (obj, bool) => {
    if (obj.IsLeaf || bool) {
      // setLoading(false)
      setItemData(obj);

      setShowTree(false);
      //  setLoading(true)
    } else {
      // Toast(trans("msg_itemleafisnotselected"), "error");
      Toast(trans("msg_itemleafisnotselected"), MessageType.error);

    }
  };
  const WarehouseIdHandeler = (obj) => {
    setWarehouseData(obj);
    setShowWarehouseTree(false);
  };

  const TaxHandler = async (Id) => {
    //  setLoading(false)
    try {
      const res = await getTaxList(Id);
      let totalTaxRate = 0;
      res.Data.map((item) => {
        totalTaxRate += item.TaxRate;
      });

      return totalTaxRate;
    } catch (error) {}
    // setLoading(true)
  };
  const handleWarehouseSelection = (obj) => {
    setWarehouseData(obj);
    setShowWarehouseTree(false);
  };

  const updateQuantity =async (newQty, priceListArray = [] ,QtyInChange=null) => {
    // if ((QtyInChange==null&&priceListDetail[priceListDetail.length - 1].SalesUnitMaxOrderQty)||(QtyInChange=="Qty"+numberOfSalesUnit&&priceListDetail[priceListDetail.length - 1].SalesUnitMaxOrderQty) ) 
    //   {
    //     //when we get priceList, we should detect that whether newQty is more than SalesUnitMaxOrderQty and change Qty to SalesUnitMaxOrderQty
    //   newQty= priceListDetail[priceListDetail.length-1].SalesUnitMaxOrderQty<=newQty?priceListDetail[priceListDetail.length-1].SalesUnitMaxOrderQty:newQty
    //   }
      // if(((firstQty==null|| !(priceListDetail.length >0)) && priceList?.HasDetailRange && mode==='edit') && ((numberOfSalesUnit==1 && newQty!==selectedObj.Qty1) ||( numberOfSalesUnit==2 && newQty!==selectedObj.Qty2))){
      //   setSavedNewQty(newQty) //to countinue with newQty and prevent to reset newQty
      //   // چون که شرط  رترن میکنه و از تابع خارج میشه مقدار جدید (نیوکیوتیوای ) ذخیره نمیشه  و مقدار قبلیشو میگیره و باید مقدار جدیدشو حفظ کنیم
        
      //   setFirstQty(selectedObj?.ItemId)
      //   fetchPriceListDetail(itemData?.Id??selectedObj?.ItemId)
      // }//in create mode uses itemData and edit,view mode uses selectedObj?.ItemId

      if(!invoiceConstraint.IsAbsoluteUnitConversionRatio!=null &&!invoiceConstraint.IsAbsoluteUnitConversionRatio&&QtyInChange){
        let newPriceData:any ={}
        if(QtyInChange=="Qty1"){
          if(numberOfSalesUnit==1){
            newPriceData =await calculatePriceData(newQty, priceListArray);
          }else{
            newPriceData =await calculatePriceData( detailPriceData.Qty2, priceListArray);
          }
        }else{
          if(numberOfSalesUnit==1){
            newPriceData =await calculatePriceData(detailPriceData.Qty1, priceListArray);
          }else{
            newPriceData =await calculatePriceData(newQty, priceListArray);
          }
        }
        let DetailPrice = {
          ...newPriceData,
          // TaxRate: taxRate || detailPriceData.TaxRate,
          Qty1:  RoundWithRoundingPlace(QtyInChange =="Qty1"? newQty: detailPriceData.Qty1,priceListDetail[0]?.Qty1RoundingPlace),
          Qty2:    RoundWithRoundingPlace(QtyInChange =="Qty1"? detailPriceData.Qty2 :newQty,priceListDetail[0]?.Qty2RoundingPlace) ,
        }
        
        if(newPriceData.PriceListUnitId==newPriceData.SalesUnitId  ){
          //درصورتی ک واحد فروش باواحد لیست قیمت برابر باشد از منطق قبل که قیمت واحد لیست قیمت را دست نزنیم و قیمت واحد فروش را تغییر دهیم نمیتوان استفاده کرد. و باید در این حالت واحد فروش و لیست قیمت را .که یکی هستند ثابت نگه داریم و واحد دیگر را تغییر دهیم 
          setDetailPriceData({
            ...DetailPrice,
            UnitPrice: (numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) * newPriceData.SalesUnitPrice/ (numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1),//بسازیمsaleUnitPriceوSubTotalPrice  را براساس unitPrice باید 
            SalesUnitPrice: newPriceData.SalesUnitPrice,  
            SubTotalPrice: (numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) * newPriceData.SalesUnitPrice,
            Price: calculateDiscountedPrice((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice: newPriceData.SalesUnitPrice ,DiscountPercent:DetailPrice.DiscountPercent}),
            Discount: calculateDiscount((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice:  newPriceData.SalesUnitPrice ,DiscountPercent:DetailPrice.DiscountPercent}),
            CustomerDiscount: calculateCusomerDiscount((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), newPriceData)

          });
        }else{
        setDetailPriceData({
          ...DetailPrice,
          SalesUnitPrice: (newPriceData.UnitPrice*(numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1))/(numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2),  
          SubTotalPrice: (numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) * (newPriceData.UnitPrice*(numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1))/(numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2),
          Price: calculateDiscountedPrice((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice:  (newPriceData.UnitPrice*(numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1))/(numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) ,DiscountPercent:DetailPrice.DiscountPercent}),
          Discount: calculateDiscount((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice:  (newPriceData.UnitPrice*(numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1))/(numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2) ,DiscountPercent:DetailPrice.DiscountPercent}),
         CustomerDiscount: calculateCusomerDiscount((numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2), {SalesUnitPrice: (newPriceData.UnitPrice*(numberOfSalesUnit==1?DetailPrice.Qty2 : DetailPrice.Qty1))/(numberOfSalesUnit==1?DetailPrice.Qty1 : DetailPrice.Qty2)}),
        });}
      }else{
        let newPriceData =await calculatePriceData(newQty, priceListArray);
       

        setDetailPriceData({
        ...newPriceData,
        Qty1:RoundWithRoundingPlace((numberOfSalesUnit === 1?1:priceListDetail[0]?.ConversionRatio)*newQty ,priceListDetail[0]?.Qty1RoundingPlace),
        Qty2: RoundWithRoundingPlace(newQty/(numberOfSalesUnit === 2?1:priceListDetail[0]?.ConversionRatio) ,priceListDetail[0]?.Qty2RoundingPlace) ,
      });

      }
  };




const fetchTaxRate =  (list) => {
  let totalTaxRate = 0;
  if(list && !!list.length){
    list.map((item) => {
      totalTaxRate += item.TaxRate;
    });
  }
  return totalTaxRate;
};


  const calculatePriceData = (newQty, priceListArray) => {
    const currentPriceList = !!priceListArray.length
      ? priceListArray
      : priceListDetail;
    let matchedPriceData = findMatchingPriceData(currentPriceList, newQty);

    matchedPriceData = matchedPriceData
      ? matchedPriceData
      : {
          ...currentPriceList[0],
          Unit2Price: 0,
          Unit1Price: 0,
          SalesUnitPrice: 0,
          DiscountPercent: 0,
        };
    return {
      ...matchedPriceData,
      UnitPrice:
        matchedPriceData?.UnitPrice || matchedPriceData?.UnitPrice == 0
          ? matchedPriceData?.UnitPrice
          : matchedPriceData?.SalesUnitId === matchedPriceData?.Unit1Id
          ? matchedPriceData?.Unit2Price
          : matchedPriceData?.Unit1Price,
      Price: calculateDiscountedPrice(newQty, matchedPriceData),
      //to set TaxRate when pricelist is manual then we sould use detailPriceData.TaxRate because we nedd to save taxrate when unitprice are changing and currentPriceList[0] is 0 because was set at first
      TaxRate: currentPriceList[0]?.TaxRate,

      Discount: calculateDiscount(newQty, matchedPriceData),
      DiscountPercent: priceList.IsManual
        ? +detailPriceData?.DiscountPercent
        : +matchedPriceData?.DiscountPercent,
      SubTotalPrice: newQty * matchedPriceData?.SalesUnitPrice,
     CustomerDiscount: calculateCusomerDiscount(newQty, matchedPriceData),
      
    };
  };

  const findMatchingPriceData = (priceList, qty) =>
    priceList.find(
      (e) =>
        (e.SalesUnitMaxOrderQty == null || +e.SalesUnitMaxOrderQty >= qty) &&
        +e.SalesUnitMinOrderQty <= qty
    );

   const calculateDiscountedPrice = (qty, priceData) =>  {
        const discount=RoundWithRoundingPlace(
          (+qty *
            (+priceData?.SalesUnitPrice *
              (+priceData?.DiscountPercent))) /
            100,
          currency?.PriceRoundingPlace,
          
        );
      if(priceData.CustomerDiscountPercent!=null&&priceData.CustomerDiscountPercent!=0){  
        const customerDiscount=RoundWithRoundingPlace(
        (+qty * (+priceData?.SalesUnitPrice * ((100- +priceData?.DiscountPercent)/100)) *(priceData.CustomerDiscountPercent/100)),
        currency?.PriceRoundingPlace,
        
      );
      const totalDiscount=discount+customerDiscount
        return RoundWithRoundingPlace(
                  (+qty *+priceData?.SalesUnitPrice ) -totalDiscount ,
                  currency?.PriceRoundingPlace,
                  
                );
      }else{
        return    RoundWithRoundingPlace(
          (+qty *+priceData?.SalesUnitPrice ) -discount ,
          currency?.PriceRoundingPlace,
          
        );
      }
  
    }

  const calculateDiscount = (qty, priceData) => {
    if (priceList.IsManual) {
      return RoundWithRoundingPlace(
        qty *
          ((priceData?.SalesUnitPrice *//استفاده از پرایس دیتا برای وقتی در حال تغییر  قیمت واحد هستیم و باید از قیمت واحد اپدیت شده و درصد تخفیف توی استیت استفاده کنیم
            detailPriceData?.DiscountPercent) /
            100),
        currency.PriceRoundingPlace,
        
      );
    } else {
      return RoundWithRoundingPlace(
        qty * ((priceData?.SalesUnitPrice * priceData?.DiscountPercent) / 100),
        currency.PriceRoundingPlace,
      );
    }
  };


     const calculateCusomerDiscount = (qty, priceData) =>{

      return RoundWithRoundingPlace(
        qty * (((priceData?.SalesUnitPrice * ((100-priceData?.DiscountPercent)/100)) *//استفاده از پرایس دیتا برای وقتی در حال تغییر  قیمت واحد هستیم و باید از قیمت واحد اپدیت شده و درصد تخفیف توی استیت استفاده کنیم
           ((priceData?.CustomerDiscountPercent??0))) / 100),
        currency.PriceRoundingPlace,
        
      );
    
  }




 const initializeFormWithSelectedObject = () => {
    setWarehouseData({
      WarehouseId: selectedObj.WarehouseId ,
      WarehouseDetailId: selectedObj?.WarehouseDetailId ,
      Title: selectedObj.WarehouseDetail
      ? `${selectedObj.Warehouse},${selectedObj.WarehouseDetail}`
      : selectedObj.Warehouse,
    });

    setDetailPriceData({...selectedObj ,
         Qty1:selectedObj.SalesUnitId === selectedObj.Unit1Id?selectedObj?.ReturnableQty>=selectedObj?.Qty1?selectedObj?.Qty1:selectedObj?.ReturnableQty:selectedObj?.Qty1,
      Qty2:selectedObj.SalesUnitId === selectedObj.Unit2Id?selectedObj?.ReturnableQty>=selectedObj?.Qty2?selectedObj?.Qty2:selectedObj?.ReturnableQty:selectedObj?.Qty2,
      UnitPrice:selectedObj.SalesUnitId === selectedObj.Unit1Id ? selectedObj?.Unit2Price : selectedObj?.Unit1Price,
      TaxRate:selectedObj.TaxRate,
      SalesUnitMaxOrderQty:selectedObj?.ReturnableQty
    })
    updatePriceListDetails([{...selectedObj,
      SalesUnitMaxOrderQty:null,
      SalesUnitMinOrderQty:0,
      MaxOrderQty:null,
      MinOrderQty:0,
      SalesUnitPrice:selectedObj.SalesUnitId === selectedObj.Unit1Id?selectedObj.Unit1Price:selectedObj.Unit2Price,
      SalesUnitId:selectedObj.SalesUnitId ,
      SalesUnitDiscount:selectedObj.Discount,
   Qty1:selectedObj.SalesUnitId === selectedObj.Unit1Id?selectedObj?.ReturnableQty>=selectedObj?.Qty1?selectedObj?.Qty1:selectedObj?.ReturnableQty:selectedObj?.Qty1,
      Qty2:selectedObj.SalesUnitId === selectedObj.Unit2Id?selectedObj?.ReturnableQty>=selectedObj?.Qty2?selectedObj?.Qty2:selectedObj?.ReturnableQty:selectedObj?.Qty2,
       

    }] , true,true)

  };

  const updatePriceListDetails = async (
    data,
    withPriceListDetail = true,
    useSelectedObj = false
  ) => {
    const [firstItem] = useSelectedObj ? [selectedObj] : data;
    setNumberOfSalesUnit(
      firstItem.SalesUnitId === firstItem.Unit1Id ||
        firstItem.SalesUnitId == GUID_EMPTY
        ? 1
        : 2
    );
    //if(mode=="create") PreInvoiceConstraint.HasTax? setTotalTaxRate(await fetchTaxRate(firstItem.ItemTaxList)):setTotalTaxRate(0)
    setRate(firstItem?.ConversionRatio);

    if (withPriceListDetail) setPriceListDetail(data);
    setItemData({
      ...itemData,
      Item: firstItem.Item ? firstItem.Item : firstItem?.ItemDescription,
      ItemId: firstItem.ItemId,
      Code: firstItem.ItemCode ? firstItem?.ItemCode : firstItem?.Code,
    });
  };


  function cancel() {
    if (sessionStorage.getItem("changingforms") + "" == "true") {
      // Toast(trans("modalclosemessage"), "warning", "alertWithoutClose", () => {
      //   sessionStorage.setItem("changingforms", "false");
      //   setUserChanges({});
      //   onHide();
      // });
      Toast(trans("modalclosemessage"), MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        onHide();
      });
    } else {
      onHide();
    }
  }
  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };

  useEffect(() => {
    if (selectedObj) {
      initializeFormWithSelectedObject();
    }
  }, []);

  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);

  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);

  useEffect(() => {
    if (detailPriceData.Qty1 == 0 || detailPriceData.Qty2 == 0) {
      setShowInvalidValue(true);
    }
  }, [detailPriceData.Qty1, detailPriceData.Qty2]);

  useEffect(() => {
      updateQuantity(detailPriceData?.['Qty' + numberOfSalesUnit],[]);
  }, [priceListDetail]);

  return (
    <div className="card " style={{ flexDirection: "row" }}>
      {showTree && (
        <ModalForm
          mode={mode}
          title="ItemTree"
          onHide={() => setShowTree(false)}
          show={showTree}
        >
          <ItemsForSell
            priceListId={priceList?.Id}
            warehouseId={warehouseData?.WarehouseId}
            warehouseDetailId={warehouseData?.WarehouseDetailId}
            onHide={() => {
              setShowTree(false);
            }}
            itemCodeHandeler={itemCodeHandeler}
          />
        </ModalForm>
      )}
      {showWarehouseTree && (
        <ModalForm
          mode={mode}
          title="warehouses"
          onHide={() => setShowWarehouseTree(false)}
          show={showWarehouseTree}
        >
          <WarehouseTreeForm
            onHide={() => {
              setShowWarehouseTree(false);
            }}
            WarehouseIdHandeler={WarehouseIdHandeler}
          />
        </ModalForm>
      )}
      <div style={{ flexWrap: "nowrap" }} className="card-body row">
        <div
          className={`card-body ${
            !!priceListDetail.length
              ? "col-12 col-md-8 col-lg-9 col-xl-10"
              : "col-12"
          }`}
        >
          {loading ? (
            <div className="container-fluid">
              <form onSubmit={handleSalesInvoiceFormSubmit}>
                <div className="row">
                  <div className="col-lg-1 col-11">
                    <WarehouseDictionaryWithAccess
                      name="Warehouse"
                      mode={"view"}
                      label="Warehouse"
                      resetForm={resetForm}
                      value={selectedObj?.WarehouseId}
                      onChange={(e, obj) => {
                        setWarehouseData({
                          // ...(warehouseData? warehouseData:{}),
                          WarehouseId: e,
                          WarehouseTitle: obj?.Name?.Description,
                          WarehouseDetailsCount:
                          obj?.Name?.WarehouseDetailsCount,
                          WarehouseDetailId: obj?.Name?.WarehouseDetailsCount>0 ?warehouseData?.WarehouseDetailId?warehouseData?.WarehouseDetailId:null:null

                        });
                        if (e !== selectedObj?.WarehouseId) {
                          setItemData(null);
                          setUserChanges({});
                          setDetailPriceData({
                            Price: 0,
                            Discount: 0,
                            SubTotalPrice: 0,
                            Qty1: 1,
                            Qty2: 1,
                            TaxRate: 0,
                          });
                          setPriceListDetail([]);
                        }
                      }}
                      required={true}
                    />
                  </div>
                  {(warehouseData?.WarehouseDetailsCount > 0 ||
                    warehouseData?.WarehouseDetailId) && (
                    <div className="col-lg-2 col-11">
                      <DictionarySelectBox
                        name="WarehouseDetail"
                        mode={"view"}
                        label="WarehouseDetail"
                        params={{ warehouseId: warehouseData.WarehouseId }}
                        onChange={(e, obj) => {
                          setWarehouseData((prev) => {
                            return {
                              ...prev,
                              WarehouseDetailId: e,
                              WarehouseDetail: obj?.Name,
                            };
                          });
                        }}
                        baseUrl={INVENTORYANDSALES_URL}
                        endPoint={
                          ENDPOINTSINVENTORYANDSALES.Inventory
                            .BaseInformationApi.WarehouseDetail.dictionary
                        }
                        value={warehouseData.WarehouseDetailId}
                        resetForm={resetForm}
                      />
                    </div>
                  )}

                  <div
                    className="col-md-3 col-11"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <Textbox
                      required
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName={"itemCode"}
                      textboxType="text"
                      resetForm={resetForm}
                      labelText={"itemCode"}
                      mode={"view"}
                      value={detailPriceData?.Code}
                      defaultValue={detailPriceData.ItemCode}
                      onChange={(e) => {
                        if (
                          e?.target.value === null ||
                          e?.target.value === ""
                        ) {
                          setDetailPriceData({
                            Price: 0,
                            Discount: 0,
                            SubTotalPrice: 0,
                            Qty1: mode != "create" ? selectedObj?.Qty1 : 1,
                            Qty2: mode != "create" ? selectedObj?.Qty2 : 1,
                          });
                          setItemData({});
                          setRate(null);
                        }
                      }}
                    />
                  </div>

                  <div className="col-lg-4 col-11">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      withChangeDir={true}
                      textboxName="ItemDescription"
                      textboxType="text"
                      labelText="ItemReview"
                      value={detailPriceData?.Item}
                      defaultValue={detailPriceData.Item}
                      resetForm={resetForm}
                      mode={"view"}
                      required={false}
                    />
                  </div>

                  <div className="col-lg-2 col-11">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="ItemTechnicalCode"
                      textboxType="text"
                      labelText="TechnicalCode"
                      value={detailPriceData.ItemTechnicalCode + ""}
                      defaultValue={detailPriceData?.ItemTechnicalCode}
                      resetForm={resetForm}
                      mode="view"
                      required={false}
                    />
                  </div>
                </div>

                <div className="row ">
                  <div className="col-lg-3 col-11">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="Qty1"
                      textboxType="number"
                      labelText="Qty1"
                      readonly={
                        numberOfSalesUnit != 1
                      }
                      //   add
                      value={detailPriceData?.Qty1 ? detailPriceData.Qty1 : 1}
                      defaultValue={
                        detailPriceData?.Qty1 ? detailPriceData.Qty1 : 1
                      }
                      usePrevDefaultValue={
                        priceList.HasDetailRange &&
                        numberOfSalesUnit == 1 &&
                        priceListDetail[priceListDetail.length - 1]
                          ?.SalesUnitMaxOrderQty === detailPriceData.Qty1
                      }
                      max={originalQty.qty1}
                      min={0}
                      resetForm={resetForm}
                      mode={mode}
                      required={true}
                      onChange={(e) => {
                        if (
                          e.target.value != "" &&
                          numberOfSalesUnit == 1 &&
                          +e.target.value >= e.target.min &&
                          (e.target.max
                            ? +e.target.value <= e.target.max
                            : true)
                        )
                          updateQuantity(+e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-lg-3 col-11">
                    <UnitDictionary
                      returnObj
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      value={detailPriceData?.Unit1Id}
                      label="Unit1"
                      name="Unit1Id"
                      required={false}
                      mode={"view"}
                      resetForm={resetForm}
                      setUnitDictionary={(e) => {
                        setDictionaryName((pre) => {
                          return { ...pre, Unit1: e.Value };
                        });
                      }}
                    />
                  </div>
                    <div className="col-lg-3 col-12">
                        {/* <Textbox
                          Change={setUserChanges}
                          textboxName={
                            numberOfSalesUnit === 1 ? "SalesUnitPrice" : "Unit1Price"
                          }
                          textboxType="text"
                          labelText="UnitPrice"
                          value={
                            detailPriceData[
                              `${numberOfSalesUnit === 1 ? "SalesUnitPrice" : "UnitPrice"}`
                            ]
                          }
                          // decimals={currency.PriceRoundingPlace}
                          defaultValue={
                            detailPriceData[
                              `${numberOfSalesUnit === 1 ? "SalesUnitPrice" : "UnitPrice"}`
                            ]
                          }
                          resetForm={resetForm}
                          mode={priceList.IsManual && mode !== "view" ? "create" : "view"}
                          useGroupingPrice={true}
                          // onChange={(e) => handleUnitPriceChange(e, "Qty1")}
                          required={false}
                        /> */}
                        <PriceInput
                          Change={setUserChanges}
                          name={
                            numberOfSalesUnit === 1 ? "SalesUnitPrice" : "Unit1Price"
                          }
                         decimals={MasterUnitPriceRoundingPlace}
                          label="UnitPrice"
                          value={
                            detailPriceData[
                              `${numberOfSalesUnit === 1 ? "SalesUnitPrice" : "UnitPrice"}`
                            ]
                          }
                          // decimals={currency.PriceRoundingPlace}
                          defaultValue={
                            detailPriceData[
                              `${numberOfSalesUnit === 1 ? "SalesUnitPrice" : "UnitPrice"}`
                            ]
                          }
                          resetForm={resetForm}
                          mode={priceList.IsManual && mode !== "view" ? "create" : "view"}
                          // onChange={(e) => handleUnitPriceChange(e, "Qty1")}
                          required={false}
                        />
                      </div>
                  <div className="col-lg-3 col-11">
                    {numberOfSalesUnit == 1 && (
                      // <Textbox
                      //   Change={(e) => {
                      //     setUserChanges({ ...userChanges, ...e });
                      //   }}
                      //   textboxName="SubTotalPrice"
                      //   textboxType="text"
                      //   labelText="مبلغ"
                      //   value={detailPriceData?.SubTotalPrice}
                      //   round={false}
                      //   defaultValue={detailPriceData?.SubTotalPrice}
                      //   resetForm={resetForm}
                      //   mode={
                      //     priceList.IsManual && mode != "view"
                      //       ? "create"
                      //       : "view"
                      //   }
                      //   useGroupingPrice={true}
                      //   required={false}
                      // />
                      <PriceInput
                          Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        name="SubTotalPrice"
                        label="مبلغ"
                        value={detailPriceData?.SubTotalPrice}
                        round={false}
                        defaultValue={detailPriceData?.SubTotalPrice}
                        resetForm={resetForm}
                        mode={
                          priceList.IsManual && mode != "view"
                            ? "create"
                            : "view"
                        }
               
                        required={false}
                      />
                    )}
                  </div>
                </div>
                <div className="row">
                  {selectedObj?.Unit2Id ? (
                    <>
                      <div className="col-lg-3 col-11">
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="Qty2"
                          textboxType="number"
                          labelText="Qty2"
                          readonly={
                            numberOfSalesUnit != 2
                          }
                          defaultValue={detailPriceData.Qty2 + ""}
                          usePrevDefaultValue={
                            priceList.HasDetailRange &&
                            numberOfSalesUnit == 2 &&
                            priceListDetail[priceListDetail.length - 1]
                              ?.SalesUnitMaxOrderQty === detailPriceData.Qty2
                          }
                          max={originalQty.qty2}
                          min={0}
                          resetForm={resetForm}
                          mode={mode}
                          required={false}
                          onChange={(e) => {
                            if (
                              e.target.value != "" &&
                              numberOfSalesUnit == 2 &&
                              +e.target.value >= e.target.min &&
                              (e.target.max
                                ? +e.target.value <= e.target.max
                                : true)
                            )
                              updateQuantity(+e.target.value);
                          }}
                        />
                      </div>
                      <div className="col-lg-3 col-11">
                        <UnitDictionary
                          returnObj
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          value={detailPriceData?.Unit2Id}
                          label="Unit2"
                          name="Unit2Id"
                          required={false}
                          mode={"view"}
                          resetForm={resetForm}
                          setUnitDictionary={(e) =>
                            setDictionaryName((pre) => {
                              return { ...pre, Unit2: e.Value };
                            })
                          }
                        />
                      </div>
                  <div className="col-lg-3 col-11">
                    {/* <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName={
                        numberOfSalesUnit == 2 ? "SalesUnitPrice" : "Unit2Price"
                      }
                      textboxType="text"
                      labelText="UnitPrice"
                      value={
                        detailPriceData?.[
                          numberOfSalesUnit == 2
                            ? "SalesUnitPrice"
                            : "UnitPrice"
                        ]
                      }
                      defaultValue={
                        detailPriceData?.[
                          numberOfSalesUnit == 2
                            ? "SalesUnitPrice"
                            : "UnitPrice"
                        ]
                      }
                      resetForm={resetForm}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      useGroupingPrice={true}
                      onChange={(e) => {
                        if (numberOfSalesUnit == 2) {
                          // setDetailPriceData({
                          //   ...detailPriceData,
                          //   SalesUnitPrice: +e.target.value.replaceAll(
                          //     ",",
                          //     ""
                          //   ),
                          //   UnitPrice:
                          //     +e.target.value.replaceAll(",", "") / rate,
                          //   SubTotalPrice:
                          //     +e.target.value.replaceAll(",", "") *
                          //     detailPriceData.Qty2,
                          // });
                          setPriceListDetail((pre) => {
                            return [
                              {
                                ...pre[0],
                                SalesUnitPrice: +e.target.value.replaceAll(
                                  ",",
                                  ""
                                ),
                                UnitPrice:
                                  +e.target.value.replaceAll(",", "") / rate,
                              },
                            ];
                          });
                        } else {
                          // setDetailPriceData({
                          //   ...detailPriceData,
                          //   SalesUnitPrice:
                          //     +e.target.value.replaceAll(",", "") * rate,
                          //   UnitPrice: +e.target.value.replaceAll(",", ""),
                          //   SubTotalPrice:
                          //     +e.target.value.replaceAll(",", "") *
                          //     rate *
                          //     detailPriceData.Qty1,
                          // });
                          setPriceListDetail((pre) => {
                            return [
                              {
                                ...pre[0],
                                SalesUnitPrice:
                                  +e.target.value.replaceAll(",", "") * rate,
                                UnitPrice: +e.target.value.replaceAll(",", ""),
                              },
                            ];
                          });
                        }
                      }}
                      required={false}
                    /> */}
                    <PriceInput
                         Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      name={
                        numberOfSalesUnit == 2 ? "SalesUnitPrice" : "Unit2Price"
                      }
                      label="UnitPrice"
                      decimals={MasterUnitPriceRoundingPlace}
                      value={
                        detailPriceData?.[
                          numberOfSalesUnit == 2
                            ? "SalesUnitPrice"
                            : "UnitPrice"
                        ]
                      }
                      defaultValue={
                        detailPriceData?.[
                          numberOfSalesUnit == 2
                            ? "SalesUnitPrice"
                            : "UnitPrice"
                        ]
                      }
                      resetForm={resetForm}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      onChange={(e) => {
                        if (numberOfSalesUnit == 2) {
                          // setDetailPriceData({
                          //   ...detailPriceData,
                          //   SalesUnitPrice: +e.target.value.replaceAll(
                          //     ",",
                          //     ""
                          //   ),
                          //   UnitPrice:
                          //     +e.target.value.replaceAll(",", "") / rate,
                          //   SubTotalPrice:
                          //     +e.target.value.replaceAll(",", "") *
                          //     detailPriceData.Qty2,
                          // });
                          setPriceListDetail((pre) => {
                            return [
                              {
                                ...pre[0],
                                SalesUnitPrice: +e.target.value.replaceAll(
                                  ",",
                                  ""
                                ),
                                UnitPrice:
                                  +e.target.value.replaceAll(",", "") / rate,
                              },
                            ];
                          });
                        } else {
                          // setDetailPriceData({
                          //   ...detailPriceData,
                          //   SalesUnitPrice:
                          //     +e.target.value.replaceAll(",", "") * rate,
                          //   UnitPrice: +e.target.value.replaceAll(",", ""),
                          //   SubTotalPrice:
                          //     +e.target.value.replaceAll(",", "") *
                          //     rate *
                          //     detailPriceData.Qty1,
                          // });
                          setPriceListDetail((pre) => {
                            return [
                              {
                                ...pre[0],
                                SalesUnitPrice:
                                  +e.target.value.replaceAll(",", "") * rate,
                                UnitPrice: +e.target.value.replaceAll(",", ""),
                              },
                            ];
                          });
                        }
                      }}
                      required={false}
                    />
                  </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {numberOfSalesUnit == 2 && (  
                    <div className="col-lg-3 col-11">
                      {/* <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="SubTotalPrice"
                        textboxType="text"
                        labelText="مبلغ"
                        value={detailPriceData?.SubTotalPrice}
                        round={false}
                        defaultValue={detailPriceData?.SubTotalPrice}
                        resetForm={resetForm}
                        mode={
                          priceList.IsManual && mode != "view"
                            ? "create"
                            : "view"
                        }
                        useGroupingPrice={true}
                        required={false}
                      /> */}
                      <PriceInput
                              Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        name="SubTotalPrice"
                        label="مبلغ"
                        value={detailPriceData?.SubTotalPrice}
                        round={false}
                        decimals={MasterUnitPriceRoundingPlace}
                        defaultValue={detailPriceData?.SubTotalPrice}
                        resetForm={resetForm}
                        mode={
                          priceList.IsManual && mode != "view"
                            ? "create"
                            : "view"
                        }
                        required={false}
                      />
                    </div>
                  )}
                </div>

                <div className="row justify-content-lg-end">
                  <div className=" col-lg-2 col-11">
                    {/* <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="DiscountPercent"
                      textboxType="text"
                      useTrans={false}
                      labelText={trans("DiscountPercent")+'%'}
                      value={
                        detailPriceData?.DiscountPercent
                          ? detailPriceData?.DiscountPercent + ""
                          : 0
                      }
                      onChange={(e) =>
                        setDetailPriceData({
                          ...detailPriceData,
                          DiscountPercent: +e.target.value,
                          Discount:
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                            100,
                          Price:
                            detailPriceData?.SubTotalPrice -
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                              100,
                        })
                      }
                      defaultValue={
                        detailPriceData?.DiscountPercent
                          ? detailPriceData.DiscountPercent + ""
                          : detailPriceData.DiscountPercent == 0
                          ? "0"
                          : "0"
                      }
                      resetForm={resetForm}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      useGroupingPrice={true}
                      required={false}
                      max={100}
                    /> */}
                    <PriceInput
                                 Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      name="DiscountPercent"
                      useTrans={false}
                      label={trans("DiscountPercent")+'%'}
                      value={
                        detailPriceData?.DiscountPercent
                          ? detailPriceData?.DiscountPercent + ""
                          : 0
                      }
                      onChange={(e) =>
                        setDetailPriceData({
                          ...detailPriceData,
                          DiscountPercent: +e.target.value,
                          Discount:
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                            100,
                          Price:
                            detailPriceData?.SubTotalPrice -
                            (+e.target.value * detailPriceData?.SubTotalPrice) /
                              100,
                        })
                      }
                      defaultValue={
                        detailPriceData?.DiscountPercent
                          ? detailPriceData.DiscountPercent + ""
                          : detailPriceData.DiscountPercent == 0
                          ? "0"
                          : "0"
                      }
                      resetForm={resetForm}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }

                      required={false}
                      max={100}
                    />
                  </div>
                  <div className=" col-lg-3 col-11">
                    {/* <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="Discount"
                      textboxType="text"
                      labelText="Discount"
                      value={
                        detailPriceData?.Discount
                          ? detailPriceData?.Discount
                          : 0
                      }
                      defaultValue={
                        detailPriceData?.Discount
                          ? detailPriceData?.Discount
                          : "0"
                      }
                      resetForm={resetForm}
                      round={false}
                      onChange={(e) => {
                        setDetailPriceData({
                          ...detailPriceData,
                          Price:
                            detailPriceData?.SubTotalPrice -
                            +e.target.value.replaceAll(",", ""),
                          Discount: +e.target.value.replaceAll(",", ""),
                          DiscountPercent:
                            (+e.target.value.replaceAll(",", "") /
                              detailPriceData?.SubTotalPrice) *
                            100,
                        });
                      }}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      useGroupingPrice={true}
                      required={false}
                    /> */}
                    <PriceInput
                          Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                     name="Discount"
                      label="Discount"
                      value={
                        detailPriceData?.Discount
                          ? detailPriceData?.Discount
                          : 0
                      }
                      defaultValue={
                        detailPriceData?.Discount
                          ? detailPriceData?.Discount
                          : "0"
                      }
                      decimals={currency.PriceRoundingPlace}
                      resetForm={resetForm}
                      round={false}
                      onChange={(e) => {
                        setDetailPriceData({
                          ...detailPriceData,
                          Price:
                            detailPriceData?.SubTotalPrice -
                            +e.target.value.replaceAll(",", ""),
                          Discount: +e.target.value.replaceAll(",", ""),
                          DiscountPercent:
                            (+e.target.value.replaceAll(",", "") /
                              detailPriceData?.SubTotalPrice) *
                            100,
                        });
                      }}
                      mode={
                        priceList.IsManual && mode != "view" ? "create" : "view"
                      }
                      required={false}
                    />
                  </div>
                </div>
                 {(detailPriceData?.CustomerDiscountPercent &&detailPriceData.CustomerDiscountPercent !=0 )?
                      <div className="row justify-content-end">
                       
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="Price2"
                          textboxType="text"
                          labelText="totalprice"
                          value={
                            detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          defaultValue={detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={ "view"   }
                          useGroupingPrice={true}

                        /> */}
                        <PriceInput
                             Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="Price2"
                          label="TotalPrice"
                          value={
                            detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          defaultValue={detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={ "view"   }

                        />
                      </div>
                      <div className="w-100"></div>
                        <div className="col-lg-2">
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="CustomerDiscountPercent"
                          textboxType="number"
                          customClass={'arrow-none'}
                          useTrans={false}
                          labelText={trans("CustomerDiscountPercent")+'%'}
                          value={priceListDetail[0]?.CustomerDiscountPercent + ""}
                          max={100}
                          min={0}
                          defaultValue={
                            priceListDetail[0]?.CustomerDiscountPercent
                              ? priceListDetail[0].CustomerDiscountPercent + ""
                              : priceListDetail[0]?.CustomerDiscountPercent == 0
                              ? "0"
                              : ""
                          }
                          resetForm={resetForm}
                          mode={ "view"}
                        />
                      </div>
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="CustomerDiscount"
                          textboxType="text"
                          labelText="CustomerDiscount" 
                          value={detailPriceData.CustomerDiscount}
                          defaultValue={detailPriceData.CustomerDiscount}
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={"view" }
                          useGroupingPrice={true}
                        /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="CustomerDiscount"
                          label="CustomerDiscount" 
                          value={detailPriceData.CustomerDiscount}
                          defaultValue={detailPriceData.CustomerDiscount}
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={"view" }
                        />
                      </div>
                      </div>:''
                      }
               <div className="row justify-content-lg-end">
                             <div className="col-11 col-lg-3">
                               {/* <Textbox
                                 Change={(e) => {
                                   setUserChanges({ ...userChanges, ...e });
                                 }}
                                 textboxName="Price"
                                 textboxType="text"
                                 labelText="totalprice"
                                 value={detailPriceData.Price + ""}
                                 defaultValue={
                                   detailPriceData?.Price ? detailPriceData.Price : null
                                 }
                              
                                 round={false}
                                 resetForm={resetForm}
                                 mode={
                                   priceList.IsManual && mode != "view" ? "create" : "view"
                                 }
                                 useGroupingPrice={true}
                                 required={false}
                               /> */}
                               <PriceInput
                                     Change={(e) => {
                                   setUserChanges({ ...userChanges, ...e });
                                 }}
                                 name="TotalPrice"
                                 label="totalprice"
                                 value={detailPriceData.Price + ""}
                                 defaultValue={
                                   detailPriceData?.Price ? detailPriceData.Price : null
                                 }
                              
                                 round={false}
                                 resetForm={resetForm}
                                 mode={
                                   priceList.IsManual && mode != "view" ? "create" : "view"
                                 }
                                 required={false}
                               />
                             </div>
                           </div>
                           {
                             <div className="row justify-content-lg-end">
                               <div className="col-lg-3 col-11">
                                 {/* <Textbox
                                   Change={(e) => {
                                     setUserChanges({ ...userChanges, ...e });
                                   }}
                                   useGroupingPrice
                                   textboxName="Tax"
                                   textboxType="text"
                                   labelText="Tax"
                                   mode={'view'}
                                   defaultValue={
                                     detailPriceData?.TaxRate
                                       ? 
                                           (+detailPriceData.TaxRate *
                                             +detailPriceData?.Price) /
                                             100
                                         + ""
                                       : "0"
                                   }
                                   value={
                                     detailPriceData?.TaxRate
                                       ? 
                                           (+detailPriceData?.TaxRate *
                                             +detailPriceData?.Price) /
                                             100 + ""
                                       : "0"
                                   }
                                   resetForm={resetForm}
                                 
                                   required={false}
                                   onChange={(e) => {
                                     if (priceList.IsManual) {
                                       setDetailPriceData({
                                         ...detailPriceData,
                                         TaxRate:
                                           (+e.target.value.replaceAll(",", "") * 100) /
                                           detailPriceData.Price,
                                       });
                                     }
                                   }}
                                 /> */}
                                 <PriceInput
                                                 Change={(e) => {
                                     setUserChanges({ ...userChanges, ...e });
                                   }}
                                  decimals={currency.PriceRoundingPlace}
                                   name="Tax"
                                   label="Tax"
                                   mode={'view'}
                                   defaultValue={
                                     detailPriceData?.TaxRate
                                       ? 
                                           (+detailPriceData.TaxRate *
                                             +detailPriceData?.Price) /
                                             100
                                         + ""
                                       : "0"
                                   }
                                   value={
                                     detailPriceData?.TaxRate
                                       ? 
                                           (+detailPriceData?.TaxRate *
                                             +detailPriceData?.Price) /
                                             100 + ""
                                       : "0"
                                   }
                                   resetForm={resetForm}
                                 
                                   required={false}
                                   onChange={(e) => {
                                     if (priceList.IsManual) {
                                       setDetailPriceData({
                                         ...detailPriceData,
                                         TaxRate:
                                           (+e.target.value.replaceAll(",", "") * 100) /
                                           detailPriceData.Price,
                                       });
                                     }
                                   }}
                                 />
                               </div>
                             </div>
                           }
           
                           <div className="row justify-content-lg-end">
                             <div className="col-lg-3 col-11">
                               {/* <Textbox
                                 Change={(e) => {
                                   setUserChanges({ ...userChanges, ...e });
                                 }}
                                 textboxName="GrandTotalPrice"
                                 textboxType="text"
                                 labelText="payableamount"
                                 value={+detailPriceData.Price+(+detailPriceData.TaxRate *
                                  +detailPriceData.Price) /
                                100 + "" }
                                defaultValue={+detailPriceData.Price+(+detailPriceData.TaxRate *
                                  +detailPriceData.Price) /
                                100 + ""}
                                 resetForm={resetForm}
                             
                                 round={false}
                                 mode={
                                   priceList.IsManual && mode != "view" ? "create" : "view"
                                 }
                                 useGroupingPrice={true}
                                 required={false}
                               /> */}
                               <PriceInput
                                  Change={(e) => {
                                   setUserChanges({ ...userChanges, ...e });
                                 }}
                                 name="GrandTotalPrice"
                                 label="payableamount"
                                 value={+detailPriceData.Price+(+detailPriceData.TaxRate *
                                  +detailPriceData.Price) /
                                100 + "" }
                                defaultValue={+detailPriceData.Price+(+detailPriceData.TaxRate *
                                  +detailPriceData.Price) /
                                100 + ""}
                                 resetForm={resetForm}
                                  decimals={currency.PriceRoundingPlace}

                                 round={false}
                                 mode={
                                   priceList.IsManual && mode != "view" ? "create" : "view"
                                 }
                                 required={false}
                               />
                             </div>
                           </div>
           
                           {detailPriceData?.HasExpireDate && (
                             <div className="col-lg-2 col-11">
                               <Datepicker
                                 mode={mode}
                                 lable="ExpireDate"
                                 setIsoTime={(isoTime: string) => {
                                   setExpireDate(isoTime);
                                 }}
                                 val={mode != "create" ? selectedObj?.ExpireDate : null} //resetForm ? new Date().toISOString() :
                                 errorFlag={false}
                                 Change={(e) => {
                                   setUserChanges({ ...userChanges, ...e });
                                 }}
                                 resetForm={resetForm}
                                 required={false}
                               />
                             </div>
                           )}
                           <div className="col">
                             <Textbox
                               Change={(e) => {
                                 setUserChanges({ ...userChanges, ...e });
                               }}
                               textboxType="textarea"
                               textboxName="Description"
                               labelText="Remarks"
                               minHeight={1}
                               defaultValue={
                                 mode != "create" ? selectedObj?.Description : null
                               }
                               resetForm={resetForm}
                               mode={mode}
                               required={false}
                               maxLength={150}
                               letterCounter={true}
                             />
                           </div>
                <>
                  {mode != "view" ? (
                    <div className="col-lg-12 mt-1 btns_form">
                      <Button value="save" btnType="submit" />
                      <Button
                        value="SaveAndClose"
                        btnType="submit"
                        onClick={() => {
                          setSave_Exit(true);
                        }}
                      />
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  ) : (
                    <div className="col-lg-12 mt-1 btns_form">
                      <Button
                        btnType="primary"
                        value="close"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  )}
                </>
              </form>
            </div>
          ) : (
            <Loading />
          )}
        </div>
        {(!!priceListDetail.length && (priceList?.HasDetailRange ) ) && (
          <PriceDetails priceListDetail={priceListDetail} />
        )}
      </div>
    </div>
  );
};
